import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import placeholderIcon from "../../assets/icon/placeholderIcon.png";
import FullScreenLoader from "../../components/fullScreenLoader/fullScreenLoader";
import { AnswerContext } from "../../store/answerStore";
import TestFooterAudio from "../testFooterAudio/testFooterAudio";
import "./speedImgRecall.scss";

import { HelperContext } from "../../store/helperStore";

export default function SpeedImgRecall({ question, questions, index }) {
  const { answerC, dispatchAnswer } = AnswerContext();
  const [visible, setVisible] = useState(false);
  const [zoomedImg, setZoomedImg] = useState();
  const { isLoading } = answerC;

  const { dispatchHelper } = HelperContext();

  const handleZoomImg = (image) => {
    setVisible(true);
    setZoomedImg(image);
  };

  useEffect(() => {
    dispatchHelper({
      type: "SET_SHUFFELED_IMAGE",
      payload: question.questionArray.reduce(
        (str, ques, i) => `${str}${i !== 0 ? "," : ""}${ques.id}`,
        ""
      ),
    });
  }, []);

  return (
    <>
      {/* this ternary condition is very important rather than and condition */}
      {isLoading ? (
        <FullScreenLoader msg="Please wait your audio is processing" />
      ) : (
        <>
          <div className="speed-img-recall">
            {question.questionArray.map((ques, index) => {
              // console.log("speedImageRecall.jsx ques", ques);
              return (
                <div
                  key={index}
                  className="speed-image"
                  //NOTE don't remove comment below
                  // onDoubleClick={() => handleZoomImg(ques.que_title1)}
                >
                  <LazyLoadImage
                    placeholderSrc={placeholderIcon}
                    alt=""
                    effect="blur"
                    src={
                      require(`../../assets/img/speedImgRecall/${ques.que_title1}.svg`)
                    }
                  />
                </div>
              );
            })}
          </div>

          <Modal
            visible={visible}
            onCancel={() => setVisible(false)}
            footer={null}
          >
            <div className="zoomed-img">
              {zoomedImg && (
                <img
                  src={
                    require(`../../assets/img/speedImgRecall/${zoomedImg}.webp`)
                  }
                  alt=""
                  className=""
                />
              )}
            </div>
          </Modal>

          <TestFooterAudio
            question={question}
            questions={questions}
            index={index}
          />
        </>
      )}
    </>
  );
}
